import React from 'react';
import { Tag } from 'antd';

export const newCons = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'app_name',
            key: 'app_name',
            fixed: 'left',
            sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
            // responsive: ["sm"],
            width: '30%',
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'category_name',
            fixed: 'left',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            // responsive: ["sm"],
            width: '20%',
        },
        {
            title: 'Activity',
            dataIndex: 'activity_added',
            key: 'activity_added',
            fixed: 'left',
            width: '20%',
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            width: '15%',
        },
        {
            title: ind,
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            width: '15%',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            render: (text, record) => {
                return <>{text !== null ? text : ''}</>;
            },
        },
    ];
};

export const modCons = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'app_name',
            key: 'app_name',
            fixed: 'left',
            sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
            // responsive: ["sm"],
            width: '20%',
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'category_name',
            fixed: 'left',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            // responsive: ["sm"],
            width: '14%',
        },
        {
            title: 'Activity Added',
            dataIndex: 'activity_added',
            key: 'activity_added',
            fixed: 'left',
            // responsive: ["sm"],
            width: '10%',
        },
        {
            title: 'Activity Removed',
            dataIndex: 'activity_removed',
            key: 'activity_removed',
            fixed: 'left',
            // responsive: ["sm"],
            width: '10%',
        },
        {
            title: 'Domain Added',
            dataIndex: 'domain_added',
            key: 'domain_added',
            fixed: 'left',
            // responsive: ["sm"],
            width: '13%',
        },
        {
            title: 'Domain Removed',
            dataIndex: 'domain_removed',
            key: 'domain_removed',
            fixed: 'left',
            // responsive: ["sm"],
            width: '13%',
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            width: '9%',
        },
        {
            title: ind,
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            width: '11%',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            render: (text, record) => {
                return <>{text !== null ? text : ''}</>;
            },
        },
    ];
};

export const remCons = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'app_name',
            key: 'app_name',
            fixed: 'left',
            sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
            // responsive: ["sm"],
            width: '35%',
        },
        {
            title: 'Action',
            dataIndex: 'request_type',
            key: 'request_type',
            fixed: 'left',
            sorter: (a, b) => (a.request_type ? a.request_type.localeCompare(b.request_type) : 1),
            // responsive: ["sm"],
            width: '30%',
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            width: '15%',
        },
        {
            title: ind,
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            width: '20%',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            render: (text, record) => {
                return <>{text !== null ? text : ''}</>;
            },
        },
    ];
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};

export const cardCss = { padding: '0', borderStyle: 'hidden' };
